/**
 * Members Reducers
 */
 import {
    MEMBER_ACTION, 
    GET_MEMBERDETAILS
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case MEMBER_ACTION:
            return { ...state, loading: true };
            
        case GET_MEMBERDETAILS:
            return { ...state, loading: false }; 

        default: return { ...state };
    }
}